import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { PH_OVERLAY_DATA } from '@ph-core/services/overlay';

import { PhNotificationPanelData } from './notification-panel-data';
import { notificationRevealTrigger } from './notification-panel.animation';
import { PhNotificationComponent } from '../notification/notification.component';
import { PhNotificationItem } from '../notification/notification.interface';

@Component({
  templateUrl: './notification-panel.component.html',
  styleUrls: ['./notification-panel.component.scss'],
  animations: [notificationRevealTrigger],
  imports: [PhNotificationComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhNotificationPanelComponent {
  private data = inject<PhNotificationPanelData>(PH_OVERLAY_DATA);

  readonly notifications = this.data.notificationService.notifications;

  closeNotification(id: string): void {
    this.data.notificationService.remove(id);
  }

  trackByID(_: number, { id }: PhNotificationItem): string {
    return id ?? '';
  }
}
